module.exports = __webpack_public_path__ + "img/workflowSettings_01.36dc1e56.png";